module.exports = __webpack_public_path__ + "img/change_1.ef60ffb3.png";